export default __webpack_public_path__ + "static/media/training-illustration9.919c3802.png";